import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 *
 * @param {Unit8Array} array
 */
var svgToPng = function svgToPng(array) {
  return new Promise(function (resolve, reject) {
    var blob = new Blob([array], {
      type: "image/svg+xml"
    }); // let reader = new FileReader();
    // reader.readAsArrayBuffer(blob);

    var url = URL.createObjectURL(blob);
    var svgImage = document.createElement("img"); // svgImage.setAttribute("id", StringUtils.guidGenerator());

    svgImage.setAttribute("id", "fake-id");
    document.body.appendChild(svgImage);

    svgImage.onload = function () {
      try {
        URL.revokeObjectURL(url);
        var canvas = document.createElement("canvas");
        canvas.width = svgImage.clientWidth;
        canvas.height = svgImage.clientHeight;
        var canvasCtx = canvas.getContext("2d");
        canvasCtx.drawImage(svgImage, 0, 0);
        var imgData = canvas.toDataURL("image/png"); //     Cross-origin occurs here

        var image = {
          image: imgData,
          svgRef: svgImage,
          result: "success"
        };
        resolve(image);
      } catch (e) {
        var _image = {
          image: null,
          svgRef: svgImage,
          result: "failure"
        };
        resolve(_image);
      }
    };

    svgImage.src = url;
  });
};

var readAsArrayBufferAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var reader = new FileReader();

              reader.onload = function () {
                resolve(reader.result);
              };

              reader.readAsArrayBuffer(file);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readAsArrayBufferAsync(_x) {
    return _ref.apply(this, arguments);
  };
}();

var previewImage = function previewImage(dataUri) {
  var preview = document.createElement('img');
  preview.src = dataUri;
  preview.style = "position: absolute; top: 0; left: 0; z-index: 10; width: 500px; height: 500px; background-color: lightgray";
  document.body.appendChild(preview);
};
/**
 *
 * @param {File} file
 */


export var handleSaveDiagram = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
    var arrayBuf, array, diagramData, convertResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return readAsArrayBufferAsync(file);

          case 2:
            arrayBuf = _context2.sent;
            array = new Uint8Array(arrayBuf);
            diagramData = array;
            _context2.next = 7;
            return svgToPng(array);

          case 7:
            convertResult = _context2.sent;
            previewImage(convertResult.image);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleSaveDiagram(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 *
 * @param {string} dataURI - base64 url
 * @returns Blob
 */

export var dataURItoBlob = function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  var byteString = window.atob(dataURI.split(',')[1]); // separate out the mime component

  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // write the bytes of the string to an ArrayBuffer

  var arrayBuffer = new ArrayBuffer(byteString.length);

  var _ia = new Uint8Array(arrayBuffer);

  for (var i = 0; i < byteString.length; i++) {
    _ia[i] = byteString.charCodeAt(i);
  }

  var dataView = new DataView(arrayBuffer);
  var blob = new Blob([dataView], {
    type: mimeString
  });
  return blob;
};